import React, { FC } from 'react';
import ForgetPasswordForm from '../../../components/ForgetPassword';

const ForgetPassword: FC = () => {
  return (
    <React.Fragment>
      <div className='h-screen flex items-center justify-center py-[20px] overflow-auto bg-gradient-to-r from-main-screen-secondary/20 to-main-screen-primary/60'>
        {/* Container */}
        <div className='flex w-[1600px] mx-auto h-full'>
          {/* Form */}
          <ForgetPasswordForm />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgetPassword;
